import { Button } from '@ets/design-system';
import { FormattedMessage } from 'react-intl';
import SavedAccount from '../SavedAccount/SavedAccount';

import { useDispatch } from '_common/hooks';
import { checkActiveAccount } from 'Auth/redux/authSlice';
import { useAuthContext } from 'Auth/AuthContext';

export const TEST_IDS = {
  OTHER_ACCOUNT_BUTTON: 'otherAccount',
  REMOVE_BUTTON: 'remove',
  CANCEL_BUTTON: 'cancel',
};

type AccountsListProps = {
  removeAccount: (userId: UserId) => void;
  useAnotherAccount: () => void;
  setSelectedAccount: (account: ParsedProfile<Account>) => void;
  removingAccounts: boolean;
  setRemovingAccounts: (removingAccount: boolean) => void;
};

const AccountsList = ({
  removeAccount,
  useAnotherAccount,
  setSelectedAccount,
  removingAccounts,
  setRemovingAccounts,
}: AccountsListProps) => {
  const dispatch = useDispatch();
  const { accounts } = useAuthContext();
  const toggleRemovingAccounts = () => setRemovingAccounts(!removingAccounts);
  const accountKeys = Object.keys(accounts);
  const hasOverflow = accountKeys.length > 5;

  const onAccountBtnClick = (account: ParsedProfile<Account>, useThirdParty: boolean) => {
    if (!removingAccounts) {
      if (account.online) {
        dispatch(checkActiveAccount({ account }));
      } else if (useThirdParty && account.third_party) {
        window.location.href = account.third_party.url;
      } else {
        const localStorage = window.localStorage.getItem('persist:localStorage');
        if (localStorage) {
          const accounts = JSON.parse(JSON.parse(localStorage).accounts);
          if (accounts[account.id]) {
            const { expires, token } = accounts[account.id];

            if (token && new Date() < new Date(expires)) {
              dispatch(checkActiveAccount({ account: { ...account, token, expires } }));
            }
          }
        }

        setSelectedAccount(account);
      }
    }
  };

  return (
    <div>
      <div className={`mb-8 max-h-[49rem] ${hasOverflow ? 'overflow-y-auto pr-4 pl-6' : ''}`}>
        {Object.keys(accounts).map((key) => (
          <div key={key} className="mt-4">
            <SavedAccount
              key={key}
              account={accounts[key]}
              removing={removingAccounts}
              onClick={onAccountBtnClick}
              removeAccount={removeAccount}
            />
          </div>
        ))}
      </div>
      <div className={` ${hasOverflow ? 'pl-6' : ''}`}>
        <Button
          size="l"
          variant="standard"
          fullWidth
          onClick={removingAccounts ? () => setRemovingAccounts(false) : useAnotherAccount}
          testId={removingAccounts ? TEST_IDS.CANCEL_BUTTON : TEST_IDS.OTHER_ACCOUNT_BUTTON}
        >
          {removingAccounts ? (
            <FormattedMessage id="global.cancel" />
          ) : (
            <FormattedMessage id="SIGN_IN_WITH_ANOTHER_ACCOUNT" />
          )}
        </Button>
        {!removingAccounts && (
          <div className="my-8 text-center">
            <Button
              variant="link"
              size="s"
              onClick={toggleRemovingAccounts}
              testId={TEST_IDS.REMOVE_BUTTON}
            >
              <FormattedMessage id="REMOVE_ACCOUNT" />
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default AccountsList;
